import * as React from 'react';
import { ca } from '@cian/analytics';
/**
 * Разметка: https://conf.cian.tech/pages/viewpage.action?pageId=1413840548
 */
export function useTracking(_ref) {
  let {
    newbuildingId,
    pageTypeJK,
    houseId
  } = _ref;
  const page = React.useMemo(() => {
    const isSeoPage = pageTypeJK === 'Seo';
    const pageType = isSeoPage ? 'Normal' : pageTypeJK;
    const extra = {
      PageTypeJK: pageType
    };
    if (isSeoPage) {
      extra.is_seo = true;
    }
    return {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra
    };
  }, [pageTypeJK]);

  /**
   * Старое событие, в статье отсутствует, используется для перехода в листинги по ссылкам
   * в нижнем блоке и при переходе в КаОб из списка планировок при наличии только одного оффера
   */
  const trackListingLinkClick = React.useCallback(action => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Card_JK',
      action,
      label: 'layout',
      page,
      products: [{
        id: newbuildingId,
        offertype: 'JK',
        extra: {
          room_num: null,
          corpus_id: houseId || null
        }
      }]
    });
  }, [page, newbuildingId, houseId]);

  /**
   * Событие открытия модалки офферов (№2)
   */
  const trackOffersModalOpen = React.useCallback(() => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'show_sopr',
      label: 'modal_open',
      page
    });
  }, [page]);

  /**
   * Событие перехода в карточку объекта из модалки офферов (№3)
   */
  const trackModalOfferLinkClick = React.useCallback(() => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'click_sopr',
      label: 'modal_open_card',
      page
    });
  }, [page]);

  /**
   * Событие перехода из модалки листинг внутри ЖК (№4)
   */
  const trackModalListingLinkClick = React.useCallback(() => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'click_sopr',
      label: 'modal_open_listing_jk',
      page
    });
  }, [page]);
  return React.useMemo(() => ({
    trackListingLinkClick,
    trackOffersModalOpen,
    trackModalOfferLinkClick,
    trackModalListingLinkClick
  }), [trackListingLinkClick, trackOffersModalOpen, trackModalOfferLinkClick, trackModalListingLinkClick]);
}